import * as ToggleGroup from '@radix-ui/react-toggle-group';
import clsx from 'clsx';

interface IframeSwitcherProps {
  options: { value: string; label: string }[];
  value: string;
  onChange: (val: string) => void;
  'aria-label': string;
}

const IframeSwitcher: React.FC<IframeSwitcherProps> = ({
  options,
  value,
  onChange,
  'aria-label': ariaLabel,
}) => (
  <ToggleGroup.Root
    type="single"
    value={value}
    onValueChange={(val) => {
      if (val !== '') {
        onChange(val);
      }
    }}
    aria-label={ariaLabel}
    className="flex gap-xs rounded-[100px] border border-neutral-400 p-[3px]"
  >
    {options.map((option) => (
      <ToggleGroup.Item
        key={option.value}
        value={option.value}
        aria-label={option.label}
        className={clsx('flex-auto rounded-xsmall p-[7px]', {
          'rounded-[100px] border border-brandMidnight bg-brandMidnight text-body1Medium text-white hover:border-brandMidnight-hover':
            value === option.value,
          'border border-transparent text-body1Light text-neutral-800 hover:bg-neutral-200':
            value !== option.value,
        })}
      >
        {option.label}
      </ToggleGroup.Item>
    ))}
  </ToggleGroup.Root>
);

export default IframeSwitcher;
